import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import { GetTemplateType } from "./TemplateForm";
import ConfirmationModal from "./common/ConfirmationModal";


export default function TemplateView({}) {

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const media_url = useContext(MEDIA_URL);
  const [template, setTemplate] = useState(Object());
  // const [groups, setGroups] = useState([]);
  const navigate = useNavigate();

  let { templateId } = useParams();
  templateId = Number(templateId);


  React.useEffect(() => {

      let template = axios_api.get(api_url + '/manage_template/' + templateId, {
        headers: {"Authorization": token},
      });
  
      template.then(
        (result) => {
          let apiReturnedTemplate = result.data;
          setTemplate(apiReturnedTemplate);
          /*
          let groups = axios_api.get(api_url + '/groups/', {
            headers: {"Authorization": token},
          });
          groups.then(
            (result) => {
              let apiReturnedGroups = result.data;
              setGroups(apiReturnedGroups);
  
            },
            (error) => {
              console.log(error)
              setGroups([]);
            }
          );
          */
        },
        (error) => {
          console.log(error);
          //setTemplate([]);
        }
      );
  
  }, []);


  function DeleteTemplateClick(id) {

    axios_api.delete(api_url + `/manage_template/` + id, {
      headers: {"Authorization": token},
    })
    .then(
      (result) => {
        console.log('template deleted');
        navigate("/templates");
      },
      (error) => {
        console.log(error);
      }
    );  
  }

  let typeDisplay = GetTemplateType(template.type);
  let templateGroups = [];
  if (template.group) {
    for (let i in template.group) {
      templateGroups.push(
        <li key={template.group[i].id} className="my-1">{template.group[i].name}</li>
      );
    }
  }

  return (
    <>

      <ConfirmationModal
        modalId="confirmTemplateDeleteModal"
        headerText="Шаблон"
        messageText={[
          "Вы уверены, что хотите удалить шаблон?"
        ]}
        confirmButtonText="Удалить" 
        Action={() => DeleteTemplateClick(template.id)}
        danger
      />

      <h4 className="m-3"><Link to={`/templates`}>к списку шаблонов и групп</Link></h4>
      <div className="row">
        <div className="col-4 m-3">
          <div className="card lk-border category-card">
            <div className="card-header text-center">
              <h4 className="m-2">{template.name}</h4>
            </div>   
            <div className="card-body p-5">
              <h5 className="">Название:</h5>
              <div className="ps-3"> 
                <b>{template.name}</b> 
              </div>
              <h5 className="mt-5">Тип шаблона:</h5>
              <div className="ps-3"> 
                <b>{typeDisplay}</b> 
              </div>
              <h5 className="mt-5">Файлы:</h5>
              <h6 className="my-3"> 
                <a className="m-2 btn btn-outline-primary lk-bootstrap-button " href={media_url + template.template_file} target="_blank" rel="noopener noreferrer">файл шаблона</a> 
                <a className="m-2 btn btn-outline-primary lk-bootstrap-button " href={media_url + template.signature_file} target="_blank" rel="noopener noreferrer">файл подписи</a>
              </h6>    
              <h5 className="mt-5 mb-4">Группы шаблона: </h5>
              <div className="ps-4">
                {templateGroups.length > 0 ? templateGroups : <p>шаблону не назначены группы</p>}
              </div>
              <div  className="mt-5 d-grid gap-2 d-md-flex">
                <Link className="lk-button" to={`/template/edit/` + templateId}>
                  Изменить
                </Link>
                {template.name !== undefined && template.name !== 'стандартный' ? 
                  <button type="button" className="ms-2 btn btn-danger lk-bootstrap-button" data-bs-toggle="modal" data-bs-target="#confirmTemplateDeleteModal" aria-label="Close">Удалить</button>
                :
                  <></>
                } 
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}